import type { IconSmallProps } from './base';
import { BaseIcon } from './base';

export function IconTada(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10.7928 9.79941L14.1262 6.3038C14.5718 5.83642 14.5718 5.05745 14.1262 4.58033L12.6498 3.03213L13.634 2L15.1104 3.5482C16.1039 4.59007 16.1039 6.29406 15.1104 7.33593L11.777 10.8315L10.7928 9.79941Z"
        fill="currentColor"
      />
      <path
        d="M8.93555 7.85199L9.48337 7.27751C9.92906 6.81012 9.92906 6.03116 9.48337 5.56378L8.93555 4.98929L9.91977 3.94742L10.4676 4.52191C11.4611 5.56378 11.4611 7.26777 10.4676 8.30964L9.91977 8.88413L8.93555 7.85199Z"
        fill="currentColor"
      />
      <path
        d="M13.6346 12.779L18.825 7.33592C19.28 6.8588 20.0135 6.8588 20.4685 7.33592L21.0163 7.91041L22.0006 6.87828L21.4527 6.30379C20.4592 5.26192 18.8343 5.26192 17.8408 6.30379L12.6504 11.7468L13.6346 12.779Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 22L14.9992 17.1315L6.64258 8.36807L2 22ZM11.6102 16.333L5.06411 18.7868L7.40397 11.9221L11.6102 16.333Z"
        fill="currentColor"
      />
      <path
        d="M15.9832 12.146L14.5068 13.6942L15.4911 14.7264L16.9674 13.1782C17.4224 12.7011 18.1559 12.7011 18.6109 13.1782L20.1058 14.7458L21.09 13.7137L19.5951 12.146C18.5923 11.1042 16.9767 11.1042 15.9832 12.146Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
